import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const subtitleStyle = css`
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

/* 문서 뷰어 진입 버튼 — key/value 목록 위에 둬서 먼저 눈에 띄게. */
export const docCtaStyle = css`
  margin-bottom: ${theme.space.md}px;
`;

export const fkSectionStyle = css`
  margin-top: ${theme.space.md}px;
  padding-top: ${theme.space.sm}px;
  border-top: 1px solid ${theme.color.border};
`;

export const fkLabelStyle = css`
  margin-bottom: ${theme.space.xs}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const relatedTableStyle = css`
  width: 100%;
  margin-top: ${theme.space.sm}px;
  border-collapse: collapse;
  font-size: ${theme.fontSize.sm}px;

  th,
  td {
    text-align: left;
    padding: ${theme.space.xs}px ${theme.space.sm}px;
    border-bottom: 1px solid ${theme.color.border};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 220px;
  }
  th {
    color: ${theme.color.textMuted};
    font-weight: 600;
  }
`;

export const relatedMsgStyle = css`
  margin-top: ${theme.space.sm}px;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;
